import { SvgElement } from '@axinom/mosaic-ui';
import * as React from 'react';
import { Link } from 'react-router-dom';
import classes from './NavigationFooter.module.scss';

export interface NavigationFooterProps {
  path: string;
}

export const NavigationFooter: React.FC<NavigationFooterProps> = ({ path }) => {
  return (
    <footer className={classes.footer}>
      <Link to={path} className={classes.link}>
        <div>
          <SvgElement viewBox="0 0 90 90" aria-label="Axinom Mosaic">
            <path
              fill="#00467d"
              d="M21.7,12.7c-9.4,4.9-14,7.3-16.6,11.6-2.6,4.3-2.6,9.6-2.6,20.1v1.1c0,10.6,0,15.8,2.6,20.1,2.6,4.3,7.3,6.7,16.6,11.6l6.7,3.5c8.1,4.3,12.2,6.4,16.6,6.4s8.5-2.1,16.6-6.4l6.7-3.5c9.4-4.9,14-7.3,16.6-11.6,2.6-4.3,2.6-9.6,2.6-20.1v-1.1c0-10.6,0-15.8-2.6-20.1-2.6-4.3-7.3-6.7-16.6-11.6l-6.7-3.5c-8.1-4.3-12.2-6.4-16.6-6.4s-8.5,2.1-16.6,6.4l-6.7,3.5Z"
            />
            <path
              fill="#28aae1"
              d="M19.6,29.5c.5-2.7,3.1-4.5,5.9-4,2.7.5,4.5,3.1,4,5.9l-5,27.1c-.5,2.7-3.1,4.5-5.9,4-2.7-.5-4.5-3.1-4-5.9l5-27.1Z"
            />
            <path
              fill="#ffc81e"
              d="M21.5,26.4c2.2-1.7,5.4-1.2,7,1l20.6,27.1c1.7,2.2,1.2,5.4-1,7-2.2,1.7-5.4,1.2-7-1l-20.6-27.1c-1.7-2.2-1.2-5.4,1-7Z"
            />
            <path
              fill="#28aae1"
              d="M64.3,25.5c2.7-.5,5.3,1.3,5.9,4l5,27.1c.5,2.7-1.3,5.3-4,5.9-2.7.5-5.3-1.3-5.9-4l-5-27.1c-.5-2.7,1.3-5.3,4-5.9Z"
            />
            <path
              fill="#f06e55"
              d="M61.2,27.4c1.7-2.2,4.8-2.7,7-1,2.2,1.7,2.7,4.8,1,7l-20.1,27.1c-1.7,2.2-4.8,2.7-7,1-2.2-1.7-2.7-4.8-1-7l20.1-27.1Z"
            />
          </SvgElement>
        </div>
        <div className={classes.footerText}>
          <div className={classes.title}>Axinom Mosaic</div>
          <div className={classes.copyright}>
            Copyright &copy; {process.env.BUILD_YEAR} Axinom - All Reserved
          </div>
        </div>
      </Link>
    </footer>
  );
};
